import React, { FC } from 'react'
import { Layout } from 'antd'

import { Header } from 'antd/lib/layout/layout'
import { BASE_MENU_TAB_PATHS, MAIN_LAYOUT } from '../utils/enums'
import LayoutBaseHeader from '../components/LayoutComponents/LayoutBaseHeader'

type Props = {
	children: any
	page?: BASE_MENU_TAB_PATHS
}

const MainLayout: FC<Props> = (props) => {
	const { children, page } = props
	return (
		<Layout className='layout'>
			<Header
				className={'w-full fixed'}
				style={{
					height: '88px',
					zIndex: MAIN_LAYOUT.Z_INDEX
				}}
			>
				<LayoutBaseHeader page={page} />
			</Header>
			<Layout className={'w-full h-auto bg-white pt-6 pr-6 pb-0 pl-6 rounded-lg'} style={{ marginTop: '88px' }}>
				{children}
			</Layout>
		</Layout>
	)
}

export default MainLayout
